import { render, staticRenderFns } from "./principal.vue?vue&type=template&id=e2a7f1ca"
import script from "./principal.vue?vue&type=script&lang=js"
export * from "./principal.vue?vue&type=script&lang=js"
import style0 from "./principal.vue?vue&type=style&index=0&id=e2a7f1ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports